import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { useCallback } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { StickyDiv } from 'shell/components/shared/sticky-div';

const ButtonsResolutionCohabitation = ({
  openModal,
}: {
  openModal: (open: true) => void;
}): React.ReactElement => {
  const handleOpenModal = useCallback(() => {
    openModal(true);
  }, [openModal]);

  return (
    <StickyDiv>
      <StepButton active fullWidth>
        <StepTypography active>Convivenza di fatto</StepTypography>
      </StepButton>
      <div className="pmi-pt-4">
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrandThird" variant="outlined" fullWidth type="submit" id="confirm">
            Conferma
          </PmiButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrandThird" variant="outlined" fullWidth type="button" id="print">
            Stampa comunicazione sciogliomento
          </PmiButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton color="cdmBrandThird" variant="outlined" fullWidth type="reset" id="reset">
            Ripulisci
          </PmiButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton
            color="cdmBrand"
            variant="contained"
            fullWidth
            onClick={handleOpenModal}
            id="deny-operation"
          >
            Annulla Operazione
          </PmiButton>
        </div>
      </div>
    </StickyDiv>
  );
};

ButtonsResolutionCohabitation.displayName = 'Resolution Cohabitation buttons component';

export default ButtonsResolutionCohabitation;
